import $ from 'jquery';

window.$ = $;
window.jQuery = $; // expose en global pour les plugins jQuery

require('multiple-select/dist/multiple-select.min.js');

import barba from '@barba/core';
import 'bootstrap';
import menu from './utils/menu';
import modal from './utils/modal';
import common from './utils/common';
import profil from './utils/profil';
import transitions from './utils/transitions';
import scroll from './utils/scroll';
import search from './utils/search';
import connexion from './utils/connexion';
import createSwiper from './utils/swiper';


// pages
import content from './pages/pages';
import accueil from './pages/accueil';
import fiches from './pages/fiches';
import contact from './pages/contact';
import compte from './pages/compte';
import calendar from './utils/calendar';
import forms from './utils/forms';
import pages from "./pages/pages";


export const mobile = {state: false};
const _no_scroll = false;

window.onbeforeunload = function () {
    window.scrollTo(0, 0);
};


$(document).ready(function () {
    // Init modules
    common.init();
    menu.init();
    scroll.init();
    modal.init();
    forms.init();


    // Contrôle mobile
    common.getWINDOW();
    mobile.state = common.$windowW < 768;


    // Barba : gestion des liens externes
    document.addEventListener('click', (event) => {
        const el = event.target.closest('a.prevent-barba');
        if (el) {
            event.preventDefault();
            if (el.href.startsWith('mailto:')) {
                window.location.href = el.href;
            } else if (el.target === '_blank') {
                window.open(el.href, '_blank', 'noopener');
            } else {
                window.location.href = el.href;
            }
            return false;
        }
    });

    let faqInstance = null;

    // Init Barba
    barba.init({
        prevent: ({el, href}) => {
            // Bypass Barba partout => full reload
            return true;
        },
        prefetchIgnore: true,   // pas de préfetch
        cacheIgnore: true,      // pas de cache Barba
        transitions: [],        // pas de transitions
        views: [
            {
                namespace: 'accueil',
                afterEnter() {
                    scroll.load();
                    accueil.init();
                },
                afterLeave() {
                    search.outFilter();
                }
            },
            {
                namespace: 'souscription',
                afterEnter() {
                    scroll.load();
                    profil.init();
                    forms.multipleSelect();
                },
                afterLeave() {
                    //search.outFilter();
                }
            },
            {
                namespace: 'connexion',
                afterEnter() {
                    scroll.load();
                    connexion.init();
                    //accueil.init();
                },
                afterLeave() {
                    //search.outFilter();
                }
            },
            {
                namespace: 'creation_compte',
                afterEnter() {
                    connexion.creationCompte();
                    forms.multipleSelect();
                },
                afterLeave() {
                    menu.closeMenu();
                }
            },
            {
                namespace: '404',
                afterEnter() {
                    scroll.update();
                    swiper.update();
                },
                afterLeave() {
                    menu.closeMenu();
                }
            },
            {
                namespace: 'groupes',
                afterEnter() {
                    pages.init();
                    scroll.load();
                },
                afterLeave() {
                    menu.closeMenu();
                }
            },
            {
                namespace: 'salles',
                afterEnter() {
                    pages.init();
                    scroll.load();
                    content.init();
                    //faqInstance = new FaqTinego('ul.__faq');
                },
                afterLeave() {
                    // if (faqInstance) faqInstance.destroy();
                    menu.closeMenu();
                }
            },
            {
                namespace: 'agenda',
                afterEnter() {
                    scroll.load();
                    calendar.init();
                    forms.selectAgenda();
                },
                afterLeave() {
                    //search.outFilter();
                    menu.closeMenu();
                }
            },
            {
                namespace: 'mentions',
                afterEnter() {
                    scroll.load();
                    swiper.update();
                },
                afterLeave() {
                    menu.closeMenu();
                }
            },
            {
                namespace: 'fiche',
                afterEnter() {
                    scroll.load();
                    fiches.init();
                },
                afterLeave() {
                    menu.closeMenu();
                }
            },
            {
                namespace: 'compte',
                afterEnter() {
                    scroll.load();
                    compte.init();
                    forms.multipleSelect();
                    //forms.init();
                },
                afterLeave() {
                    menu.closeMenu();
                }
            },
            {
                namespace: 'contact',
                afterEnter() {
                    scroll.load();
                    common.init();
                    contact.init();
                },
                afterLeave() {
                    menu.closeMenu();
                }
            }
        ],
        debug: false
    });

    // Resize reload (mobile switch)
    $(window).on("debouncedresize", function () {
        common.getWINDOW();
        if (common.$windowW <= 768 && !mobile.state) {
            location.reload();
            mobile.state = true;
        } else if (common.$windowW > 768 && mobile.state) {
            location.reload();
            mobile.state = false;
        }
    });
});
